export const spacing = {
  s0: '0',
  s8: '0.5rem',
  s12: '0.75rem',
  s16: '1rem',
  s24: '1.5rem',
  s32: '2rem',
  s40: '2.5rem',
  s48: '3rem',
  s56: '3.5rem',
  s64: '4rem',
  s72: '4.5rem',
  s80: '5rem',
  s96: '6rem',
  s112: '7rem',
  s128: '8rem',
  s144: '9rem',
  s160: '10rem',
  s176: '11rem',
  s192: '12rem',
  s208: '13rem',
  s224: '14rem',
  s240: '15rem',
  s256: '16rem',
  s288: '18rem',
  s320: '20rem',
  s384: '24rem',
}
